import {RiddleData} from 'entities'
import {APIService, type InstanceApi} from 'services/api/api'
import type {LangType, MessagesType} from 'src/lib/translates/types'
import {LANGS} from 'src/lib/translates/consts'
import {getCurrentURL} from 'src/lib/getCurrentURL'
import type {
  CheckLetterParamsType,
  JsonRiddleData,
  ResponseCheckLetter,
  APIServiceRiddles,
  GetRiddlesCountParamsType,
  GetRiddleDataParamsType,
} from './entities'
import {getRandomIndexWithCheck} from 'src/lib/getRandomCeil'

class LocalApiServiceRiddles implements APIServiceRiddles {

  cachRiddles: Record<LangType, JsonRiddleData[] | null> | null = null
  riddles: JsonRiddleData[] | null = null;
  api: InstanceApi | null = null;

  public async init(messages?: MessagesType) {
      const api = new APIService({
          messages,
          apiVersion: '',
      })
      this.api = api.getInstanse();
      this.cachRiddles = {
        [LANGS.EN]: null,
        [LANGS.RU]: null,
        [LANGS.UK]: null,
        [LANGS.TR]: null,
      }
  }

  private getRiddlesDataUrl(lang: LangType) {
    let url = ''
    switch(lang) {
      case LANGS.EN: {
        url = RIDDLESJSONEN
        break
      }
      case LANGS.RU: {
        url = RIDDLESJSONRU
        break
      }
      case LANGS.UK: {
        url = RIDDLESJSONUK
        break
      }
      case LANGS.TR: {
        url = RIDDLESJSONTR
        break
      } 
      default: url = RIDDLESJSONRU
    }
    url = getCurrentURL() + url
    return url
  }

  public async getRiddles(lang: LangType) {
    if (this.cachRiddles && this.api) {
      if (this.cachRiddles[lang] === null) {
        this.cachRiddles[lang] = (await this.api.get(this.getRiddlesDataUrl(lang))).data
      }
      return this.cachRiddles[lang]
    }
  }

  public async getRiddlesCount (params: GetRiddlesCountParamsType) {
    const riddles = await this.getRiddles(params.lang)
    return riddles?.length ?? 0
  }

  public async getRiddleData(params: GetRiddleDataParamsType): Promise<RiddleData> { 
      this.riddles = await this.getRiddles(params.lang ?? LANGS.RU) ?? []
      if (this.riddles && this.riddles.length > 0) {

        const riddles = this.riddles
        const index: number = getRandomIndexWithCheck(
          (index: number) => params.answered.includes(riddles[index]._id),
          this.riddles.length-1,
        )
        const {_id, riddle, answer} = this.riddles[index]

        return Promise.resolve({
          id: _id,
          riddle,
          countLetters: answer.length,
        })
      }
      throw Error('getRiddleData: no riddles');
  }

  public checkLetter = async (params: CheckLetterParamsType): Promise<ResponseCheckLetter> => {
      const { id, letter } = params;
      const riddle = this.riddles?.find((item) => item._id === id)
      if (riddle) {
          const result: ResponseCheckLetter = {
              status: false,
              letter,
              positions: [],
          }

          let word = riddle.answer;
          let pos = word.indexOf(letter);
          while(pos >= 0) {
              result.status = true;
              result.positions.push(pos);
              word = word.replace(letter,'_');
              pos = word.indexOf(letter);
          }
          return Promise.resolve(result);
      }
      throw Error('getRiddleData: Riddle id is not found');
  }
}

export const localApiServiceRiddles = new LocalApiServiceRiddles();
